/**
 * @generated SignedSource<<be349d3c633b588dd00c26a86c015643>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoadTermDatesQuery$variables = {
  schoolId?: string | null | undefined;
  skipSchoolTermDates: boolean;
  startingYear: number;
};
export type LoadTermDatesQuery$data = {
  readonly schoolTermDates?: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly firstDayOfSecondHalfOfTerm: string | null | undefined;
        readonly firstDayOfTerm: string | null | undefined;
        readonly id: string;
        readonly lastDayOfFirstHalfOfTerm: string | null | undefined;
        readonly lastDayOfTerm: string | null | undefined;
        readonly term: number | null | undefined;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly termDates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly firstDayOfSecondHalfOfTerm: string | null | undefined;
        readonly firstDayOfTerm: string | null | undefined;
        readonly id: string;
        readonly lastDayOfFirstHalfOfTerm: string | null | undefined;
        readonly lastDayOfTerm: string | null | undefined;
        readonly term: number | null | undefined;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type LoadTermDatesQuery = {
  response: LoadTermDatesQuery$data;
  variables: LoadTermDatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schoolId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipSchoolTermDates"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startingYear"
},
v3 = {
  "kind": "Variable",
  "name": "startingYear",
  "variableName": "startingYear"
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "TermDatesNodeEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TermDatesNode",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "term",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstDayOfTerm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastDayOfFirstHalfOfTerm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstDayOfSecondHalfOfTerm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastDayOfTerm",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      (v3/*: any*/)
    ],
    "concreteType": "TermDatesNodeConnection",
    "kind": "LinkedField",
    "name": "termDates",
    "plural": false,
    "selections": [
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  {
    "condition": "skipSchoolTermDates",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": "schoolTermDates",
        "args": [
          {
            "kind": "Variable",
            "name": "schoolId",
            "variableName": "schoolId"
          },
          (v3/*: any*/)
        ],
        "concreteType": "TermDatesNodeConnection",
        "kind": "LinkedField",
        "name": "termDates",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadTermDatesQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoadTermDatesQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "885941926cac54270646bd1231c1ea79",
    "id": null,
    "metadata": {},
    "name": "LoadTermDatesQuery",
    "operationKind": "query",
    "text": "query LoadTermDatesQuery(\n  $schoolId: ID\n  $startingYear: Int!\n  $skipSchoolTermDates: Boolean!\n) {\n  termDates(startingYear: $startingYear) {\n    edges {\n      node {\n        id\n        term\n        firstDayOfTerm\n        lastDayOfFirstHalfOfTerm\n        firstDayOfSecondHalfOfTerm\n        lastDayOfTerm\n      }\n    }\n  }\n  schoolTermDates: termDates(schoolId: $schoolId, startingYear: $startingYear) @skip(if: $skipSchoolTermDates) {\n    edges {\n      node {\n        id\n        term\n        firstDayOfTerm\n        lastDayOfFirstHalfOfTerm\n        firstDayOfSecondHalfOfTerm\n        lastDayOfTerm\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8430f84d950080ef70803ce939bcd27a";

export default node;
